/*
ABOUT >>
THIS INPUT USED FOR CALLING API FOR SOFTWARE DROPDOWN 
FULLY DYNAMIC DATASOURCES BY USING API ROUTES 

ACTIVE >>
ITS IN RUNNING POSITION

UPDATES >>
IT WILL BE UPDATE FOR CALLING API FOR LIST DATASOURCE IF DataSourceType IS Route and give parameters with this api
*/




// This is the latest file

import http from '../../services/http-common';
import securityService from '../security/security.service';

class ApiService {
    getAllForList(type) {
         let companyID = securityService.getCompanyIDLoggedInUserId()
                console.log(' DropdownService type', type)
                console.log(' DropdownService companyID',companyID)
    return http.get(`/dropdownApi/${type}/${companyID}`);
}
}

export default new ApiService();